<template>
    <q-dialog v-model="show" @input="(val) => $emit('change-visibility', val)">
        <q-card class="q-card-container">
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">
                    <translate>SEARCH</translate>
                </div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>
            <q-card-section class="q-pt-none">
                <q-form @submit.prevent="onSubmit" class="q-gutter-md q-form">
                    <div class="grouped-inputs">
                        <jt-month-picker class="col-3 q-px-sm q-mt-md jt-month-picker" v-if="show"
                            :float-label="$gettext('DATE')" :name="$gettext('DATE')"
                            v-model="form.date" color="primary" required />
                        <q-select emit-value map-options outlined v-model="form.technologies" use-chips multiple
                            @blur="reloadResidues" :options="comboTreatmentType" :label="$gettext('TECHNOLOGY')"
                            class="col-3 q-px-sm q-mt-md tech-combo" >
                            <template v-slot:no-option>
                            <q-item>
                                <q-item-section class="text-grey">
                                    <translate>NO_RESULT</translate>
                                </q-item-section>
                            </q-item>
                        </template>
                        </q-select>
                    </div>
                    <q-select v-if="filterByResidues" emit-value map-options outlined v-model="form.residues"
                        :options="comboResidues" use-chips multiple :label="$gettext('RESIDUE_SINGULAR')"
                        class="col-3 q-px-sm q-mt-md q-field--with-bottom">
                        <template v-slot:no-option>
                            <q-item>
                                <q-item-section class="text-grey">
                                    <translate>NO_RESULT</translate>
                                </q-item-section>
                            </q-item>
                        </template>
                    </q-select>
                    <q-card-actions align="center" class="bg-white text-teal">
                        <q-btn :label="$gettext('CANCEL')" v-close-popup color="white" flat
                            class="bg-grey-7 buttons-action" />
                        <q-btn :label="$gettext('FILTER')" type="submit" color="primary" class="buttons-action" />
                    </q-card-actions>
                </q-form>
            </q-card-section>

        </q-card>
    </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtMonthPicker, JtDatetime, JtSelect } from 'jtech-webcomps'
import { repository } from 'jtech'

@Component({
  name: 'TechnologyDashboardModalFilter',
  props: {
    show: {
      default: false,
      type: Boolean
    },
    filterByResidues: {
      default: true,
      type: Boolean
    }
  },
  components: { JtMonthPicker, JtDatetime, JtSelect }
})
class TechnologyDashboardModalFilter extends Vue {
    form = {
      date: null,
      technologies: [],
      residues: []
    }

    comboTreatmentType = []
    comboResidues = []

    onSubmit () {
      this.$emit('submit', this.form)
      this.$emit('change-visibility', false)
    }

    async mounted () {
      const techCombo = await repository.resolve('technologyDashboard.filterTicketsGroupByResidues')
      this.comboTreatmentType = techCombo[0].relacionamentos.obterTodosExcetoAterro
    }

    async reloadResidues () {
      if (this.filterByResidues) {
        this.form.residues = []
        const objectToSend = this.form.technologies.map(e => { return { treatmentType: e } })
        if (objectToSend.length == 0) {
          this.comboResidues = []
          return
        }
        const { registros } = await repository.resolveLogic('technologyDashboard.getResiduesByTreatmentType', { treatmentType: objectToSend })
        this.comboResidues = registros
      }
    }
}
export default TechnologyDashboardModalFilter
</script>
<style scoped>
.buttons-action {
    width: 100px;
}

.q-card-container {
    width: 600px;
    max-width: 80vw;
}

.q-form {
    margin-top: 18px;
}

.grouped-inputs {
    display: flex;
}

.jt-month-picker {
    padding-bottom: 0;
    max-width: 30%;
}

.tech-combo {
    width: 70%;
    max-width: 70%;
}
</style>
